module.exports = __webpack_public_path__ + "static/media/gridview.ee7ceea6.png";